<script>
  import headers from '../data/headers-for-games-table.json';
  import DataTableSimple from '@/components/tables/DataTableSimple.vue';
  import { CURRENCIES } from '@/store';

  export default {
    name: 'GameHistory',

    components: {
      DataTableSimple,
    },

    data: () => ({
      filter: {},
      headers,
    }),

    methods: {
      valueToText(value, currency) {
        const parsedValue = parseFloat(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        if (currency === CURRENCIES.MQC) {
          return `${parsedValue} QC`;
        }
        return `$${parsedValue}`;
      },
    },

    computed: {
      gameHistoryData() {
        let historyData = this.$store.getters.getGameHistory;

        historyData.sort((a, b) => b.created - a.created);

        return historyData.map((item) => {
          return {
            ...item,
            total_bet: this.valueToText(item.total_bet, item.currency),
            total_win: this.valueToText(item.total_win, item.currency),
          };
        });
      },
    },

    created() {
      this.$store.dispatch('getGameHistory');
    },
  };
</script>

<template>
  <div>
    <div class="mx-auto" style="width: 100%; max-width: 800px">
      <p class="text-center font-size-20 font-weight-400 py-5" style="font-style: initial; color: #7f71aa">
        Note that this page shows bids you placed in the last six months (limited to 50 bids).
        <br />
        To get the history of your bids for a later period, please contact our support team.
      </p>
    </div>
    <div class="table-container">
      <data-table-simple
        :headers="headers"
        :items="gameHistoryData"
        :items-per-page="10000"
        class="mx-auto"
        style="width: 100%; max-width: 800px"
      />
    </div>
  </div>
</template>
